import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box, Text } from '@chakra-ui/react';
import { Field } from 'formik';
import NameField from '@/components/forms/new/formikFormFields/NameField';
import FieldToolTip from '@/components/forms/new/FieldToolTip';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    descriptionStyling,
} from '@/components/forms/new/formStyles';

const GroupNameField = ({
    darkMode,
    serviceWizard,
    walkthroughId,
    errors,
    touched,
}) => {
    const [isHovered, setIsHovered] = useState(false);

    const handleInputChange = (e) => {
        serviceWizard.setFilterGroup(e?.target?.value);
    };

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={!!errors.filterGroup && touched.filterGroup}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={stackStyling(true)}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Group Name
                    </FormLabel>
                    <Text sx={descriptionStyling}>
                        Enter the Active Directory Group Name
                    </Text>
                </Box>
                <Field
                    component={NameField}
                    id="filterGroup"
                    name="filterGroup"
                    darkMode={darkMode}
                    onChange={handleInputChange}
                    value={serviceWizard?.filterGroup}
                    data-walkthroughid={walkthroughId}
                />
                {isHovered && (
                    <FieldToolTip
                        label="The name of the Active Directory group to sync"
                        ariaLabel="group-name-field-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default GroupNameField;
